import React from "react";
import { Button, Col, Row, Table } from "antd";
import "./PlanDetail.css";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import ExtraPaymentModal from "../extra-payment-modal/ExtraPaymentModal";
import AddModalUser from "./../user-modal/AddModalUser";
import CloseWindowModal from "./../../sign-in-modal/CloseWindowModal";
import { updateClientes } from "../../../actions/ClientAction";
import { updatePlanServicesByUser } from "../../../actions/PlanServicesAction";
import {
  getPlanServicesByUser,
  updatePlanLinkGenerate,
  reducePlan
} from "../../../actions/PlanServicesAction";
import { getUsers } from "../../../actions/UsersAction";
import _ from "lodash";
import {
  updateClientPlans,
  calculateDiff,
  isEnterpriseUser
} from "../../../utils/plan-utils";
import queryString from "query-string";
import InfoModal from "./info-modal/InfoModal";
import { getClientDataById } from "../../../actions/ClientAction";

class PlanDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      dataDiff: [],
      isPremium: true,
      isChanged: false,
      showExtraPaymentModal: false,
      loadingFetchData: false,
      showAddModalUser: false,
      showCloseWindowModal: false,
      showInfoModal: false
    };
    const { newColor } = this.props;

    this.columns = [
      {
        title: "Item",
        key: "item",
        dataIndex: "item",
        render: (value, row) => {
          const obj = {
            children: row.is_first
              ? value.charAt(0).toUpperCase() + value.slice(1)
              : "",
            props: {}
          };
          if (row.key === -1) obj.props.colSpan = 2;
          return obj;
        }
      },
      {
        title: "Producto",
        key: "product",
        dataIndex: "product",
        render: (value, row) => {
          const obj = {
            children: value,
            props: {}
          };
          if (row.key === -1) obj.props.colSpan = 0;
          return obj;
        }
      },
      {
        title: "Cantidad",
        key: "quantity",
        dataIndex: "quantity",
        render: (value, row) => {
          return (
            <>
              {row.key === -1 ? (
                <span style={{ fontWeight: 700 }}>{value}</span>
              ) : row.type === "3" ? (
                <span style={{ fontWeight: 700 }}></span>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: 100,
                    margin: "0 auto"
                  }}
                >
                  {this.state.isPremium &&
                    row.is_free === "false" &&
                    !isEnterpriseUser(this.props.client.clientType) && (
                      <Button
                        type={"primary"}
                        style={{
                          margin: "0 auto",
                          display: "block",
                          width: 27,
                          backgroundColor: newColor,
                          borderColor: newColor
                        }}
                        size={"small"}
                        onClick={() => this.addAmountItemPlan(row.key, -1)}
                      >
                        <span>
                          <img
                            src="/images/img_v2/icon-btn-minus.svg"
                            alt="filtro"
                          />
                        </span>
                      </Button>
                    )}
                  <Button
                    style={{
                      margin: "0 auto",
                      display: "block",
                      borderWidth: row.is_free === "true" ? 2.0 : 1.0,
                      backgroundColor:
                        row.is_free === "true" ? "#F4F4F4" : "#FFFFFF",
                      borderColor: newColor
                    }}
                    size={"small"}
                  >
                    {value}
                  </Button>
                  {this.state.isPremium &&
                    row.is_free === "false" &&
                    !isEnterpriseUser(this.props.client.clientType) && (
                      <Button
                        type={"primary"}
                        style={{
                          margin: "0 auto",
                          display: "block",
                          width: 27,
                          padding: "0 4px",
                          backgroundColor: newColor,
                          borderColor: newColor
                        }}
                        size={"small"}
                        onClick={() => this.addAmountItemPlan(row.key, 1)}
                      >
                        <span>
                          <img
                            src="/images/img_v2/icon-btn-add.png"
                            alt="filtro"
                          />
                        </span>
                      </Button>
                    )}
                </div>
              )}
            </>
          );
        }
      },
      {
        title: "Precio",
        key: "price",
        dataIndex: "price",
        render: (value, row) => (
          <span style={{ fontWeight: row.key === -1 ? 700 : 400 }}>
            {Number(value).toFixed(2)} USD
          </span>
        )
      },
      {
        title: "Duración",
        key: "expDate",
        dataIndex: "expDate",
        render: (value, row) => (
          <span style={{ fontWeight: 400 }}>
            {_.isNil(value) && row.key !== -1 ? "Indefinido" : ""}
          </span>
        )
      }
    ];
    this.addModalUserRef = React.createRef();
  }

  handleShowAddModalUser = () => {
    this.setState({
      showAddModalUser: true
    });
  };

  handleHiddenAddModalUser = () => {
    this.setState({
      showAddModalUser: false
    });
  };

  handleShowModalExtraPayment = () => {
    this.setState({
      showExtraPaymentModal: true
    });
  };

  handleHiddenModalExtraPayment = () => {
    this.setState({
      showExtraPaymentModal: false
    });
  };

  componentDidMount() {
    let qs = queryString.parse(this.props.location.search);
    if (qs["show-alert"] === "1") {
      this.setState({
        showInfoModal: true
      });
    }
    const { workclient } = this.props;
    this.getRecordsFetch();
    this.props.getClientDataById(workclient);
    this.props.getUsers(workclient, 1, null, true);
  }

  componentDidUpdate(prevProps, prevState) {
    const { data: oldData } = prevState;

    const {
      data: newData,
      showExtraPaymentModal,
      showAddModalUser
    } = this.state;

    const {
      userServices,
      linkGenerateLoading: linkGenerateLoadingNew,
      linkGenerateError,
      linkGenerate,
      reducePlanLoading: reducePlanLoadingNew,
      workclient,
      intl,
      reducePlanError
    } = this.props;

    const {
      linkGenerateLoading: linkGenerateLoadingOld,
      reducePlanLoading: reducePlanLoadingOld
    } = prevProps;

    if (this.props.userServices !== prevProps.userServices) {
      const data = (this.props.userServices || []).map(item => ({
        ...item,
        key: item.idService ? item.idService : item._id,
        _id: item.idService ? item.idService : item._id
      }));
      this.setState({
        data: data,
        oldData: data
      });
    }
    if (newData !== oldData) {
      const newDiff = calculateDiff(userServices, newData);
      this.setState({
        dataDiff: newDiff
      });
    }
    if (
      linkGenerateLoadingOld &&
      !linkGenerateLoadingNew &&
      !linkGenerateError &&
      linkGenerate
    ) {
      if (showExtraPaymentModal || showAddModalUser) return;
      window.open(linkGenerate, "_self", "noreferrer");
    }
    if (reducePlanLoadingOld && !reducePlanLoadingNew && !reducePlanError) {
      if (showExtraPaymentModal || showAddModalUser) return;
      const newDataClean = newData.filter(e => e.idService);
      this.props.updatePlanServicesByUser(
        workclient,
        newDataClean.map(x => ({ ...x, qty: x.quantity })),
        intl
      );
    }
  }

  handleCalculateTotal() {
    const dataStatePrev = this.state.data.filter(item => item.key !== -1);
    this.setState({
      data: [
        ...dataStatePrev,
        {
          key: -1,
          quantity: "Total",
          price: this.state.data.reduce((prev, curr) => {
            if (curr.key !== -1) return curr.price * curr.quantity + prev;
            else return prev;
          }, 0)
        }
      ]
    });
  }

  addAmountItemPlan = (id, quantity) => {
    const { data } = this.state;
    const ind = data.findIndex(item => item.key === id);
    if (ind >= 0) {
      data[ind].quantity += quantity;
      if (data[ind].quantity <= 0) delete data[ind];
      this.setState({ data, isChanged: true });
    }
    this.handleCalculateTotal();
  };

  getRecordsFetch = () => {
    const { workclient } = this.props;
    this.props.getPlanServicesByUser(workclient);
  };

  updateClient = () => {
    const { client, intl, workclient } = this.props;
    const { data, dataDiff } = this.state;
    const { usersData, planServices } = this.props;

    const resp = updateClientPlans(
      client,
      intl,
      data,
      dataDiff,
      usersData,
      planServices
    );
    if (resp.action === "error") return;
    if (resp.action === "reduce_plan") {
      this.props.reducePlan(workclient, resp.data.amount, intl);
      return;
    }
    if (resp.action === "update_plan") {
      const cleanModules = resp.data.modules.filter(e => e.idService);
      this.props.updatePlanLinkGenerate(
        workclient,
        resp.data.amount,
        intl,
        cleanModules
      );
      return;
    }
  };

  sortFunctionalitites(data) {
    const newData = data.map(e => ({
      ...e,
      id: e._id
    }));
    const usersGroup = newData.filter(e => e.type === "1");
    const storageGroup = newData.filter(e => e.type === "2");
    const funcGroup = newData.filter(e => e.type === "3");
    const usersFree = usersGroup
      .filter(e => e.is_free === "true")
      .map(e => ({
        ...e,
        is_first: true
      }));
    const usersNotFree = usersGroup.filter(e => e.is_free === "false");
    const storageFree = storageGroup
      .filter(e => e.is_free === "true")
      .map(e => ({
        ...e,
        is_first: true
      }));
    const storageNotFree = storageGroup.filter(e => e.is_free === "false");

    const newFuncGroup =
      funcGroup.length === 1
        ? [
            {
              ...funcGroup[0],
              is_first: true
            }
          ]
        : funcGroup.length > 1
        ? [
            {
              ...funcGroup[0],
              is_first: true
            },
            ...funcGroup.slice(1)
          ]
        : funcGroup;

    return [
      ...usersFree,
      ...usersNotFree,
      ...storageFree,
      ...storageNotFree,
      ...newFuncGroup
    ];
  }

  render() {
    const {
      data,
      isChanged,
      showExtraPaymentModal,
      showAddModalUser,
      showCloseWindowModal,
      showInfoModal
    } = this.state;
    const {
      intl,
      loadingFetch,
      fetchingUserServices,
      newColor,
      linkGenerateLoading,
      reducePlanLoading,
      client
    } = this.props;

    return (
      <div className={"container"}>
        <Row>
          <Col span={24}>
            <h4 className="title-dashboard">
              <b className="color-title-dashboard">Detalles del plan</b>
            </h4>
          </Col>
        </Row>
        <div className="container">
          <div className="table-responsive">
            <Table
              columns={this.columns}
              dataSource={this.sortFunctionalitites(data)}
              loading={fetchingUserServices || loadingFetch}
              pagination={false}
              bordered
            />
          </div>
          <div className="form-inline" style={{ marginTop: 35 }}>
            {!isEnterpriseUser(client.clientType) && (
              <div style={{ float: "left" }}>
                <Button
                  type="primary"
                  style={{
                    marginRight: 10,
                    backgroundColor: newColor,
                    borderColor: newColor
                  }}
                  onClick={this.handleShowModalExtraPayment}
                >
                  {intl.formatMessage({ id: "hire_functionality" })}
                </Button>
                <Button
                  type="primary"
                  style={{
                    marginRight: 10,
                    backgroundColor: newColor,
                    borderColor: newColor
                  }}
                  onClick={this.handleShowAddModalUser}
                >
                  {intl.formatMessage({ id: "buy_user" })}
                </Button>
              </div>
            )}
            <div style={{ float: "right" }}>
              {isChanged && (
                <>
                  <Button
                    type="default"
                    onClick={this.getRecordsFetch}
                    disabled={loadingFetch}
                  >
                    {intl.formatMessage({ id: "cancel_button" })}
                  </Button>
                  <Button
                    type="primary"
                    style={{
                      marginLeft: 10,
                      backgroundColor: newColor,
                      borderColor: newColor
                    }}
                    onClick={this.updateClient}
                    loading={
                      loadingFetch || linkGenerateLoading || reducePlanLoading
                    }
                  >
                    {intl.formatMessage({ id: "update_plan" })}
                  </Button>
                </>
              )}
            </div>
          </div>
        </div>
        <div style={{ paddingTop: "50px" }}>
          <div style={{ color: "#6F6F6F", fontWeight: 600, fontSize: 25 }}>
            {intl.formatMessage({ id: "legal-title" })}
          </div>
          <p>{intl.formatMessage({ id: "legal-content" })}</p>
        </div>

        <ExtraPaymentModal
          showModalExtraPayment={showExtraPaymentModal}
          handleHiddenModalExtraPayment={this.handleHiddenModalExtraPayment}
        />
        <AddModalUser
          showAddModalUser={showAddModalUser}
          handleShowAddModalUser={this.handleShowAddModalUser}
          handleHiddenAddModalUser={this.handleHiddenAddModalUser}
        />
        <CloseWindowModal
          showCloseWindowModal={showCloseWindowModal}
          title="Puede cerrar esta ventana o refrescarla luego de haber completado el pago"
        />
        <InfoModal
          showModal={showInfoModal}
          handleHiddenModal={() => {
            this.setState({
              showInfoModal: false
            });
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    workclient: state.client.workclient,
    client: state.client.data,
    fetchingUserServices: state.planServices.fetchingUserServices,
    userServices: state.planServices.userServices,
    usersData: state.users.data,
    planServices: state.planServices.data,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    linkGenerateLoading: state.planServices.linkGenerateLoading,
    linkGenerateError: state.planServices.linkGenerateError,
    linkGenerate: state.planServices.linkGenerate,
    reducePlanLoading: state.planServices.reducePlanLoading,
    reducePlanError: state.planServices.reducePlanError
  };
};

const mapDispatchToProps = {
  updateClientes,
  getPlanServicesByUser,
  updatePlanServicesByUser,
  getUsers,
  updatePlanLinkGenerate,
  reducePlan,
  getClientDataById
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(PlanDetail))
);
